import { GridOptions } from '@ag-grid-community/core';

import { AgRawTooltip } from '@shared/components/ag-raw-tooltip/ag-raw-tooltip';
import { TableConstants } from '@shared/constants/table.constants';

import { QuarterCloseAdjustmentGridData } from '../quarter-close-adjustments.model';
import { isTotalRow } from './ima-grid-config-context';

const DEFAULT_IN_MONTH_ADJUSTMENT_GRID_CONFIG: GridOptions<QuarterCloseAdjustmentGridData> = {
  ...TableConstants.DEFAULT_GRID_OPTIONS.EDIT_GRID_OPTIONS,
  defaultColDef: {
    ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
    filter: true,
    menuTabs: ['filterMenuTab'],
    resizable: true,
    sortable: true,
    suppressMenu: false,
    tooltipComponent: AgRawTooltip,
    tooltipValueGetter: (params) => {
      if (isTotalRow({ node: params.node })) {
        return '';
      }

      return params.valueFormatted || '';
    },
  },
  groupIncludeTotalFooter: false,
  headerHeight: 48,
  rowBuffer: 20, // ~960px range
  rowHeight: 35,
  stopEditingWhenCellsLoseFocus: true,
  suppressAggFuncInHeader: true,
  suppressColumnVirtualisation: true, // Disabled to be able to make focus to the first editable cell in the grid
  suppressPropertyNamesCheck: true,
  tooltipShowDelay: 500,
};

export default DEFAULT_IN_MONTH_ADJUSTMENT_GRID_CONFIG;
